import { gql } from '@apollo/client';

export const GET_ASSETS2_TRANSCODING_FAILURE = gql`
  query getAssets2TranscodingFailure($assetId: String!) {
    getAssets2TranscodingFailure(assetId: $assetId) {
      ... on Asset2TranscodeInfo {
        details
        failureMessage
        id
        mediaDeliveryId
        message
        name
        playbackId
        status
      }
    }
  }
`;
